import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import React, { FC, useState } from 'react'
import DenyIcon from '@/assets/icons/actions/deny.svg'
import DeleteIcon from '@mui/icons-material/Delete'
import { uploadFile } from '@/api'
import CustomImageCard from '@/components/card/CustomImageCard'

type Attachment = {
  id: number
  fileName: string
  presignedUrl: string
  fileType: string
  attachmentType: string
}

const contractors = [
  {
    id: 1,
    name: '2DZMART',
    dateCreated: '2025-02-28T07:00:02.543094',
    dateModified: '2025-02-28T07:00:02.543108',
  },
  {
    id: 2,
    name: 'GBL-R',
    dateCreated: '2025-02-28T07:00:02.548791',
    dateModified: '2025-02-28T07:00:02.548802',
  },
  {
    id: 3,
    name: 'AV Builders',
    dateCreated: '2025-02-28T07:00:02.550667',
    dateModified: '2025-02-28T07:00:02.550674',
  },
  {
    id: 4,
    name: 'MBB',
    dateCreated: '2025-02-28T07:00:02.553029',
    dateModified: '2025-02-28T07:00:02.553036',
  },
  {
    id: 5,
    name: 'Rvalloworks',
    dateCreated: '2025-02-28T07:00:02.55468',
    dateModified: '2025-02-28T07:00:02.554687',
  },
  {
    id: 6,
    name: 'Fabrencon',
    dateCreated: '2025-02-28T07:00:02.556809',
    dateModified: '2025-02-28T07:00:02.556817',
  },
  {
    id: 7,
    name: 'CMV',
    dateCreated: '2025-02-28T07:00:02.559299',
    dateModified: '2025-02-28T07:00:02.559306',
  },
  {
    id: 8,
    name: 'Kris Kat',
    dateCreated: '2025-02-28T07:00:02.562712',
    dateModified: '2025-02-28T07:00:02.562719',
  },
  {
    id: 9,
    name: 'Gan Jean',
    dateCreated: '2025-02-28T07:00:02.565348',
    dateModified: '2025-02-28T07:00:02.565355',
  },
  {
    id: 10,
    name: 'LMW',
    dateCreated: '2025-02-28T07:00:02.567705',
    dateModified: '2025-02-28T07:00:02.567712',
  },
  {
    id: 11,
    name: 'Cabaluna',
    dateCreated: '2025-02-28T07:00:02.57008',
    dateModified: '2025-02-28T07:00:02.570087',
  },
  {
    id: 12,
    name: 'Edjan',
    dateCreated: '2025-02-28T07:00:02.572639',
    dateModified: '2025-02-28T07:00:02.572646',
  },
  {
    id: 13,
    name: 'LAD',
    dateCreated: '2025-02-28T07:00:02.575238',
    dateModified: '2025-02-28T07:00:02.575245',
  },
  {
    id: 14,
    name: 'Virsons',
    dateCreated: '2025-02-28T07:00:02.578314',
    dateModified: '2025-02-28T07:00:02.578321',
  },
  {
    id: 15,
    name: 'HYM',
    dateCreated: '2025-02-28T07:00:02.580938',
    dateModified: '2025-02-28T07:00:02.580944',
  },
  {
    id: 16,
    name: 'Wallmount',
    dateCreated: '2025-02-28T07:00:02.584962',
    dateModified: '2025-02-28T07:00:02.58497',
  },
  {
    id: 17,
    name: 'Imaginary Line',
    dateCreated: '2025-02-28T07:00:02.588253',
    dateModified: '2025-02-28T07:00:02.588262',
  },
  {
    id: 18,
    name: 'JPJ',
    dateCreated: '2025-02-28T07:00:02.591203',
    dateModified: '2025-02-28T07:00:02.591209',
  },
  {
    id: 19,
    name: 'Exist',
    dateCreated: '2025-02-28T07:00:02.594051',
    dateModified: '2025-02-28T07:00:02.594057',
  },
].sort((a, b) => a.name.localeCompare(b.name))
interface QuotationDataProps {
  data: {
    contractorName: string
    amount: string | number
    remark: string
    isAwarded: boolean
    attachments: Attachment[]
    dateCreated: string
  }
  ticketId: number
  index: number
  onChange: (
    index: number,
    field: string,
    value: string | boolean | number | Attachment | Attachment[],
  ) => void
  onDelete: (index: number) => void
  handleAddAttachment: (index: number, value: Attachment) => void
  handleDeleteAttachment: (attachmentIndex: number, index: number) => void
  disabled: boolean
}

export const QuotationData: FC<QuotationDataProps> = ({
  data,
  index,
  onChange,
  onDelete,
  handleAddAttachment,
  handleDeleteAttachment,
  ticketId,
  disabled,
}) => {
  const [loading, setLoading] = useState(false)
  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    setLoading(true)
    if (!file) {
      console.warn('No file selected')
      return
    }

    const formData = new FormData()
    formData.append('file', file)

    try {
      const { data } = await uploadFile({
        ticketId: ticketId,
        attachmentType: 'CONTRACTOR_QUOTATION',
        formData,
      })

      const { id, fileName } = data.data.attachment
      const { presignedUrl, fileType } = data.data

      handleAddAttachment(index, {
        id,
        fileName,
        presignedUrl,
        attachmentType: 'CONTRACTOR_QUOTATION',
        fileType: fileType,
      })
    } catch (error) {
      console.error('File upload failed:', error)
    } finally {
      setLoading(false)
      e.target.value = ''
    }
  }

  return (
    <Grid2
      container
      spacing={2}
      gap={2}
      justifyContent="space-evenly"
      borderRadius={2}
      p={2}
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'auto 1fr .2fr auto' },
      }}
    >
      {/* Checkbox & Delete Button Side by Side, Aligned at the Top */}

      <Grid2 container alignItems="flex-start" gap={0}>
        {/* Delete Button */}
        <IconButton
          onClick={() => {
            onDelete(index)
          }}
          sx={{
            outline: 'none',
            '&:focus': {
              outline: 'none',
            },
            visibility: disabled ? 'hidden' : null,
          }}
          disabled={disabled}
        >
          <img src={DenyIcon} alt="Delete" width={24} height={24} />
        </IconButton>

        {/* Checkbox */}
        <Checkbox
          onChange={(e) => onChange(index, 'isAwarded', e.target.checked)}
          value={data.isAwarded}
          checked={data.isAwarded}
          sx={{
            '&.Mui-checked': {
              color: '#3F3D56',
            },
            // visibility: disabled ? 'hidden' : null,
          }}
          disabled={
            disabled ||
            !data.contractorName ||
            !data.amount ||
            data.attachments.length === 0
          }
        />
      </Grid2>

      {/* Contractor & Amount */}
      <Grid2>
        <Grid2
          container
          spacing={2}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <Grid2 sx={{ display: 'flex', gap: 2 }}>
            <FormControl size="small" fullWidth>
              <InputLabel id="contractorName">Contractor</InputLabel>
              <Select
                labelId="contractorName"
                label="Contractor"
                onChange={(e) => {
                  const name = e.target.value
                  const selectedContractor = contractors.find(
                    (contractor) => contractor.name === name,
                  )
                  onChange(index, 'contractorName', e.target.value)
                  const contractorId = selectedContractor?.id || 0
                  onChange(index, 'contractorId', contractorId)
                }}
                disabled={disabled}
                value={data.contractorName}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 120,
                      overflowY: 'auto',
                    },
                  },
                }}
                required
                error={!data.contractorName}
              >
                {contractors?.map((data, index) => (
                  <MenuItem key={index} value={data.name}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
              {!data.contractorName && (
                <FormHelperText error>This field is required</FormHelperText>
              )}
            </FormControl>

            <TextField
              label="Amount"
              value={
                disabled
                  ? new Intl.NumberFormat(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    }).format(
                      parseFloat(
                        String(data.amount || 0)
                          .toString()
                          .replace(/,/g, ''),
                      ),
                    )
                  : data.amount
              }
              size="small"
              type="text"
              required
              disabled={disabled}
              error={!data.amount}
              helperText={!data.amount ? 'This field is required' : null}
              fullWidth
              onChange={(e) => {
                if (disabled) return
                const rawInput = e.target.value.replace(/[^0-9.]/g, '')
                if (/^\d*\.?\d{0,3}$/.test(rawInput) || rawInput === '') {
                  onChange(index, 'amount', rawInput)
                }
              }}
              onBlur={() => {
                const num =
                  parseFloat(String(data.amount).replace(/,/g, '')) || 0

                const formatted = new Intl.NumberFormat(undefined, {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                }).format(num)

                onChange(index, 'amount', formatted)
              }}
            />
          </Grid2>
          <TextField
            label="Remarks"
            multiline
            value={data.remark}
            size="small"
            // required
            // error={!data.remark}
            disabled={disabled}
            // helperText={!data.remark ? 'This field is required' : null}
            fullWidth
            onChange={(e) => onChange(index, 'remark', e.target.value)}
            minRows={3}
          />
        </Grid2>
      </Grid2>

      {/* Attach Button */}
      {!disabled && (
        <Grid2
          container
          direction="column"
          alignItems="flex-start"
          justifyContent={'flex-start'}
          sx={{
            height: { xs: 'auto', sm: 140, md: 140 },
            gap: 0.5,
            width: '110px',
          }}
        >
          <Button
            variant="contained"
            component="label"
            sx={{
              width: '100%',
              background: '#484554',
            }}
            disabled={loading || disabled}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              'Attach'
            )}
            <input
              type="file"
              hidden
              multiple
              accept="image/*,application/pdf"
              onChange={handleFileUpload}
            />
          </Button>
          {data.attachments.length == 0 && (
            <FormHelperText
              sx={{
                color: 'red',
                maxWidth: '100%',
              }}
            >
              This field is required
            </FormHelperText>
          )}
        </Grid2>
      )}

      {/* Attachments */}
      <Grid2>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            height: { xs: 'auto' },
            width: '100%',
            minWidth: '120px',
          }}
        >
          {Array.isArray(data?.attachments) && data?.attachments?.length > 0
            ? data.attachments?.map((item, attachmentIndex) => (
                <Box
                  key={attachmentIndex}
                  display={'flex'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <CustomImageCard
                    src={item.presignedUrl}
                    attachmentNumber={item.fileName}
                    attachmentName={item.fileName}
                    attachmentType={item.fileType}
                    cardMaxHeight={{ xs: 40, sm: 40, md: 40 }}
                    cardWidth={{ xs: '100%', sm: 70, md: 80 }}
                    cardMinHeight={40}
                    imageMaxHeight={15}
                  />
                  {!disabled && (
                    <IconButton>
                      <DeleteIcon
                        onClick={() => {
                          handleDeleteAttachment(attachmentIndex, index)
                        }}
                        sx={{ fontSize: 20, color: 'inherit' }}
                      />
                    </IconButton>
                  )}
                </Box>
              ))
            : null}
        </Box>
      </Grid2>
    </Grid2>
  )
}
